import { DormitoryServicePath } from "utils/constants";

export const dormitoryRequests = {
  // Buildings
  getBuildingsSelect: () => `${DormitoryServicePath}buildings/select`,
  getBuildingRooms: id => `${DormitoryServicePath}buildings/${id}/rooms`,
  activateBuilding: id => `${DormitoryServicePath}buildings/${id}/activate`,
  deactivateBuilding: id => `${DormitoryServicePath}buildings/${id}/deactivate`,

  // Rooms
  getRoomsSelect: () => `${DormitoryServicePath}rooms/select`,
  activateRoom: id => `${DormitoryServicePath}rooms/${id}/activate`,
  deactivateRoom: id => `${DormitoryServicePath}rooms/${id}/deactivate`,
  // A room's condition is normally derived from its occupancy; these two override it with a manual
  // one and hand it back to that calculation. Both answer 204.
  setRoomCondition: id => `${DormitoryServicePath}rooms/${id}/condition`,
  resetRoomCondition: id => `${DormitoryServicePath}rooms/${id}/condition/reset`,

  // Room types
  getRoomTypesSelect: () => `${DormitoryServicePath}room-types/select`,
  activateRoomType: id => `${DormitoryServicePath}room-types/${id}/activate`,
  deactivateRoomType: id => `${DormitoryServicePath}room-types/${id}/deactivate`,

  // Room conditions
  getRoomConditionsSelect: () => `${DormitoryServicePath}room-conditions/select`,
  activateRoomCondition: id => `${DormitoryServicePath}room-conditions/${id}/activate`,
  deactivateRoomCondition: id => `${DormitoryServicePath}room-conditions/${id}/deactivate`,

  // Accommodation prices (nested under room types)
  createAccommodationPrice: typeId => `${DormitoryServicePath}room-types/${typeId}/prices`,
  getAccommodationPrice: (typeId, id) => `${DormitoryServicePath}room-types/${typeId}/prices/${id}`,
  updateAccommodationPrice: (typeId, id) => `${DormitoryServicePath}room-types/${typeId}/prices/${id}`,

  // State subsidies (nested under room types)
  createStateSubsidy: typeId => `${DormitoryServicePath}room-types/${typeId}/subsidies`,
  getStateSubsidy: (typeId, id) => `${DormitoryServicePath}room-types/${typeId}/subsidies/${id}`,
  updateStateSubsidy: (typeId, id) => `${DormitoryServicePath}room-types/${typeId}/subsidies/${id}`,

  // Campaigns
  getCampaignsSelect: () => `${DormitoryServicePath}campaigns/select`,
  confirmCampaign: id => `${DormitoryServicePath}campaigns/${id}/confirm`,
  finishCampaign: id => `${DormitoryServicePath}campaigns/${id}/finish`,
  cancelCampaign: id => `${DormitoryServicePath}campaigns/${id}/cancel`,

  // Campaign applications (nested under campaigns)
  getCampaignApplications: campaignId => `${DormitoryServicePath}campaigns/${campaignId}/applications`,
  getCampaignApplicationById: (campaignId, applicationId) =>
    `${DormitoryServicePath}campaigns/${campaignId}/applications/${applicationId}`,
  allocateCampaignApplication: (campaignId, applicationId) =>
    `${DormitoryServicePath}campaigns/${campaignId}/applications/${applicationId}/allocate`,
  rejectCampaignApplication: (campaignId, applicationId) =>
    `${DormitoryServicePath}campaigns/${campaignId}/applications/${applicationId}/reject`,

  // Accommodations
  createAccommodation: () => `${DormitoryServicePath}accommodations`,
  getAccommodationById: id => `${DormitoryServicePath}accommodations/${id}`,
  getAccommodationsSelect: () => `${DormitoryServicePath}accommodations/select`,
  checkOutAccommodation: id => `${DormitoryServicePath}accommodations/${id}/check-out`,
  confirmAccommodationMove: id => `${DormitoryServicePath}accommodations/${id}/move/confirm`,
  cancelAccommodationMove: id => `${DormitoryServicePath}accommodations/${id}/move/cancel`,

  // Accommodation orders
  cancelAccommodationOrder: id => `${DormitoryServicePath}accommodation-orders/${id}/cancel`,

  // Accommodation payments (nested under accommodations)
  refundAccommodationPayment: (accommodationId, paymentId) =>
    `${DormitoryServicePath}accommodations/${accommodationId}/payments/${paymentId}/refund`,
  recordAccommodationPayment: (accommodationId, paymentId) =>
    `${DormitoryServicePath}accommodations/${accommodationId}/payments/${paymentId}/record`,
};
